import cx from 'classnames';
import { PropsWithChildren } from 'react';
import { Typography } from '@arionbanki/arionui';
import { useProgressBar } from './useProgressBar';

type ProgressBarProps = Readonly<PropsWithChildren & { page: string }>;

export function ProgressBar({ children, page }: ProgressBarProps) {
	const { labels, labelsIndexes, progress, step, steps } = useProgressBar(page);

	if (!steps || !labels.length) return <>{children}</>;

	return (
		<div className="row">
			<div className="col-3">
				<div className="desktop-progress-bar-wrapper">
					<div className="progress-bar-line-wrapper">
						<div className="progress-bar-line">
							<div className="progress-bar" style={{ height: progress }}></div>
						</div>
						{labels.map(label => (
							<Typography className={cx({ bold: !!~labelsIndexes[label].indexOf(step) })} key={label} TagName="p">
								{label}
							</Typography>
						))}
					</div>
				</div>
			</div>
			<div className="col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
				<div className="mobile-progress-bar">
					<div className="mobile-progress-bar--indicator" style={{ width: progress }} />
				</div>
				{children}
			</div>
		</div>
	);
}
